import {connect} from '@modifi/redux'
import {aCloseDialog} from '@modifi/plugin-dialogs'
import EditTransactionDialog, {EditTransactionDialogProps} from './EditTransactionDialog'
import {aFetchTransaction} from '../../../../data/transaction'
import {
  aTagTransaction,
  aCleanupTag,
  selectTagPending,
  selectTagErrorMessage,
} from '../../../../modules/tag-transaction/store'

export const DIALOG_NAME = 'edit-transaction'

const mapStateToProps = (
  state: Record<string, any>
): Pick<EditTransactionDialogProps, 'isTagging' | 'tagError'> => ({
  isTagging: selectTagPending(state),
  tagError: selectTagErrorMessage(state),
})

const mapDispatchToProps = {
  tagTransaction: aTagTransaction,
  fetchTransaction: aFetchTransaction,
  cleanupTag: aCleanupTag,
  handleClose: aCloseDialog,
}

export default connect(mapStateToProps, mapDispatchToProps)(EditTransactionDialog)
